// Project 3: Personality system types

export type AgeGroup = '10s' | '20s' | '30s' | '40s' | '50s' | '60s';
export type Gender = 'male' | 'female' | 'neutral';
export type Occupation = 'student' | 'office' | 'freelancer' | 'creator' | 'professional' | 'retired';
export type Tone = 'bright' | 'calm' | 'sharp' | 'humor' | 'emotional' | 'logical';
export type Purpose = 'diary' | 'sns' | 'blog' | 'business' | 'novel' | 'paper';

export interface PersonalityProfile {
  id?: number;
  ageGroup: AgeGroup;
  gender: Gender;
  occupation: Occupation;
  tone: Tone;
  purpose: Purpose;
  writingStyle?: string;
  sampleText?: string;
  createdAt?: string;
  updatedAt?: string;
}

export const PERSONALITY_PRESETS: PersonalityProfile[] = [
  {
    ageGroup: '20s',
    gender: 'neutral',
    occupation: 'creator',
    tone: 'bright',
    purpose: 'blog',
    writingStyle: '트렌디하고 친근한 톤으로 독자와 소통하는 스타일',
  },
  {
    ageGroup: '30s',
    gender: 'neutral',
    occupation: 'professional',
    tone: 'logical',
    purpose: 'business',
    writingStyle: '전문적이고 신뢰할 수 있는 톤으로 정보를 제공하는 스타일',
  },
  {
    ageGroup: '40s',
    gender: 'neutral',
    occupation: 'professional',
    tone: 'calm',
    purpose: 'blog',
    writingStyle: '차분하고 균형잡힌 톤으로 깊이 있는 내용을 전달하는 스타일',
  },
  {
    ageGroup: '20s',
    gender: 'neutral',
    occupation: 'freelancer',
    tone: 'humor',
    purpose: 'sns',
    writingStyle: '유머러스하고 재미있게 정보를 전달하는 스타일',
  },
];

export const AGE_GROUP_LABELS: Record<AgeGroup, string> = {
  '10s': '10대',
  '20s': '20대',
  '30s': '30대',
  '40s': '40대',
  '50s': '50대',
  '60s': '60대',
};

export const GENDER_LABELS: Record<Gender, string> = {
  male: '남성',
  female: '여성',
  neutral: '중성',
};

export const OCCUPATION_LABELS: Record<Occupation, string> = {
  student: '학생',
  office: '직장인',
  freelancer: '프리랜서',
  creator: '창작자',
  professional: '전문직',
  retired: '은퇴자',
};

export const TONE_LABELS: Record<Tone, string> = {
  bright: '밝음',
  calm: '차분',
  sharp: '날카로움',
  humor: '유머',
  emotional: '감성적',
  logical: '논리적',
};

export const PURPOSE_LABELS: Record<Purpose, string> = {
  diary: '일기',
  sns: 'SNS',
  blog: '블로그',
  business: '비즈니스',
  novel: '소설',
  paper: '논문',
};

